import { CSSProperties } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import grid from '../images/grid.svg';

class OverlayProps {
    show?: boolean
}

export function LoadingOverlay(props: OverlayProps) {
    const wrapperStyle: CSSProperties = {
        zIndex: 999,
        backgroundColor: '#222',
        boxShadow: 'inset 0 0 5rem rgba(0, 0, 0, .5)',
        backgroundImage: `url(${grid})`
    }

    if (props.show) {
        return (
            <div style={wrapperStyle} className="h-100 w-100 position-fixed d-flex justify-content-center align-items-center">
                <h1 className="bg-darker p-3">
                    <FontAwesomeIcon className="ping delay-1" transform={{ y: 0, x: -2 }} size="sm" icon={['fab', 'ethereum']} />
                    <FontAwesomeIcon className="ping delay-2" transform={{ y: 0, x: -2 }} size="sm" icon={['fab', 'ethereum']} />
                    <FontAwesomeIcon className="ping delay-3" transform={{ y: 0, x: -2 }} size="sm" icon={['fab', 'ethereum']} />
                    <span className="text-avenir-ul">LOADING</span>
                </h1>
            </div>
        );
    } else {
        return (null);
    }
}